import {Control} from 'ol/Control';
import {UI} from './ui';
import FullScreenIcon from 'bootstrap-icons/icons/fullscreen.svg?raw'
import FullScreenExitIcon from 'bootstrap-icons/icons/fullscreen-exit.svg?raw'
import { NSPageLabels } from './page_labels';

export class ImersiveModeControl extends Control {
    element = null;
    
    constructor(opt_options) {
      const options = opt_options || {};

      const enterImersiveModeButton = document.createElement('button');
      enterImersiveModeButton.title = NSPageLabels.f_get_label_text_by_internal_name('imersive_mode_enter');
      enterImersiveModeButton.type = 'button';
      enterImersiveModeButton.innerHTML = FullScreenIcon;

      enterImersiveModeButton.onclick = () => {
        enterImersiveModeButton.classList.add('d-none');
        exitImersiveModeButton.classList.remove('d-none');
        UI.toggle_full_screen_mode();
      }

      const exitImersiveModeButton = document.createElement('button');
      exitImersiveModeButton.classList.add('d-none');
      exitImersiveModeButton.title = NSPageLabels.f_get_label_text_by_internal_name('imersive_mode_exit');
      exitImersiveModeButton.type = 'button';
      exitImersiveModeButton.innerHTML = FullScreenExitIcon;

      exitImersiveModeButton.onclick = () => {
        enterImersiveModeButton.classList.remove('d-none');
        exitImersiveModeButton.classList.add('d-none');
        UI.toggle_full_screen_mode();
      }

      const element = document.createElement('div');
      element.className = ' ol-imersive-mode ol-unselectable ol-control';
      element.appendChild(enterImersiveModeButton);
      element.appendChild(exitImersiveModeButton);
  
      super({
        element: element,
        target: options.target,
      });

      this.element = element;
    }
  }